var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    _vm._g(
      {
        attrs: {
          xmlns: "http://www.w3.org/2000/svg",
          width: "40",
          height: "40",
          fill: "none"
        }
      },
      _vm.$listeners
    ),
    [
      _c("path", {
        attrs: {
          fill: "#D6FB00",
          "fill-rule": "evenodd",
          d:
            "M9.756 0h20.493c3.398 0 4.633.357 5.872 1.02A6.894 6.894 0 0 1 38.98 3.9C39.646 5.145 40 6.374 40 9.771v20.483c0 3.396-.353 4.63-1.02 5.873a6.946 6.946 0 0 1-2.86 2.858C34.883 39.648 33.648 40 30.25 40H9.756c-3.398 0-4.633-.352-5.877-1.015a6.96 6.96 0 0 1-2.86-2.858C.354 34.884 0 33.65 0 30.254V9.77c0-3.396.353-4.625 1.02-5.869A6.909 6.909 0 0 1 3.88 1.02C5.132.357 6.357 0 9.755 0Z",
          "clip-rule": "evenodd"
        }
      }),
      _c("path", {
        attrs: {
          fill: "#000",
          "fill-rule": "evenodd",
          d: "M5.333 30.667h29.334v4H5.333v-4ZM18 5.333h4V26h-4V5.333Z",
          "clip-rule": "evenodd"
        }
      }),
      _c("path", {
        attrs: {
          fill: "#000",
          "fill-rule": "evenodd",
          d:
            "m10.92 19.748 2.828-2.829 5.919 5.92 5.919-5.92 2.828 2.829-8.747 8.747-8.748-8.747Z",
          "clip-rule": "evenodd"
        }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }